/**
 * Demo profile fixtures: a fixed roster of test users with stable keys and
 * names, most with photo URLs.
 *
 * Profiles A through L use real face images from the public photos bucket;
 * X/Y/Z are name-only so demos can exercise the coloured-initials fallback
 * (its colour is hashed from the key) without serving an image.
 * `defaultProfileList` is the canonical roster: `TestDatastore` answers
 * `profiles.get` from it, so a demo gets working bylines for keys `a`–`z`
 * without declaring anything.
 */

import type { UserProfile } from '@repo/shared/orpc/types';

function faceUrl(face: string) {
    return 'https://psi.newpublic.org/faces/' + face;
}

export const profileA: UserProfile = { profileKey: 'a', name: 'Alice Adams', photoUrl: faceUrl('face9.jpeg') };
export const profileB: UserProfile = { profileKey: 'b', name: 'Bob Bauer', photoUrl: faceUrl('face10.jpeg') };
export const profileC: UserProfile = {
    profileKey: 'c',
    name: 'Camila Costa',
    photoUrl: faceUrl('face7.jpeg'),
    isAffiliated: true,
    title: 'Editor',
};
export const profileD: UserProfile = {
    profileKey: 'd',
    name: 'Daniel Dubois',
    photoUrl: faceUrl('face2.jpeg'),
    isAffiliated: true,
    title: 'Journalist',
};
export const profileE: UserProfile = { profileKey: 'e', name: 'Emeka Eze', photoUrl: faceUrl('face4.jpeg') };
export const profileF: UserProfile = { profileKey: 'f', name: 'Finn Fischer', photoUrl: faceUrl('face3.jpeg') };
export const profileG: UserProfile = { profileKey: 'g', name: 'Grace Gomes', photoUrl: faceUrl('face8.jpeg') };
/** @public — rest of the roster, for a future caller. */
export const profileH: UserProfile = { profileKey: 'h', name: 'Hiroshi Hasegawa', photoUrl: faceUrl('face6.jpeg') };
/** @public */
export const profileI: UserProfile = { profileKey: 'i', name: 'Ingrid Ishida', photoUrl: faceUrl('face5.jpeg') };
/** @public */
export const profileJ: UserProfile = { profileKey: 'j', name: 'Jamal Joubert', photoUrl: faceUrl('face1.jpeg') };
const profileK: UserProfile = { profileKey: 'k', name: 'Keita Khan', photoUrl: faceUrl('face3.jpeg') };
const profileL: UserProfile = { profileKey: 'l', name: 'Larry Leclerc', photoUrl: faceUrl('face4.jpeg') };
export const profileX: UserProfile = { profileKey: 'x', name: 'Xavier Xerxes' };
export const profileY: UserProfile = { profileKey: 'y', name: 'yoghurt' };
export const profileZ: UserProfile = { profileKey: 'z', name: 'zipedeedoodah' };

export const defaultProfileList: UserProfile[] = [
    profileA,
    profileB,
    profileC,
    profileD,
    profileE,
    profileF,
    profileG,
    profileH,
    profileI,
    profileJ,
    profileK,
    profileL,
    profileX,
    profileY,
    profileZ,
];
